<div class="flex flex-row items-center">
  <img [class.large]="large" class="logo-icon" src="/assets/images/icon/fitmed-icon-coloured.svg" alt="FitMed Icon">
</div>
